var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// index.ts
var client_exports = {};
__export(client_exports, {
  STAGING_ENDPOINT: () => STAGING_ENDPOINT,
  getFileServiceClient: () => getFileServiceClient
});
module.exports = __toCommonJS(client_exports);

// client.ts
var import_api = require("@opentelemetry/api");
var STAGING_ENDPOINT = "https://staging.heyglide.com/service/file-service";
var getFileServiceClient = (config) => {
  var _a, _b;
  const baseUrl = (_b = (_a = config.baseUrl) != null ? _a : process.env.FILE_SERVICE_ENDPOINT) != null ? _b : STAGING_ENDPOINT;
  const bearerToken = config.token;
  const inferContentType = (filename) => {
    var _a2;
    const extension = (_a2 = filename.split(".").pop()) == null ? void 0 : _a2.toLowerCase();
    const mimeTypes = {
      // Images
      jpg: "image/jpeg",
      jpeg: "image/jpeg",
      png: "image/png",
      gif: "image/gif",
      webp: "image/webp",
      svg: "image/svg+xml",
      // Documents
      pdf: "application/pdf",
      doc: "application/msword",
      docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      xls: "application/vnd.ms-excel",
      xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      ppt: "application/vnd.ms-powerpoint",
      pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
      // Text
      txt: "text/plain",
      csv: "text/csv",
      json: "application/json",
      xml: "application/xml",
      html: "text/html",
      css: "text/css",
      js: "application/javascript",
      ts: "application/typescript",
      // Archives
      zip: "application/zip",
      tar: "application/x-tar",
      gz: "application/gzip",
      // Video
      mp4: "video/mp4",
      avi: "video/x-msvideo",
      mov: "video/quicktime",
      wmv: "video/x-ms-wmv",
      // Audio
      mp3: "audio/mpeg",
      wav: "audio/wav",
      ogg: "audio/ogg",
      m4a: "audio/mp4"
    };
    return mimeTypes[extension || ""] || "application/octet-stream";
  };
  return {
    /**
     * Gets a signed upload URL for a file.
     *
     * This method requests a pre-signed URL from the file service that allows direct upload
     * to cloud storage without exposing credentials to the client.
     *
     * @param filename - The name of the file to upload
     * @param retentionPeriod - Number of days to retain the file (defaults to config.retentionPeriod or 2)
     * @returns Promise that resolves to an UploadUrlResponse containing the file ID, upload URL, and expiration time
     * @throws Error if the request fails (e.g., invalid token, network error)
     */
    getUploadUrl(_0) {
      return __async(this, arguments, function* ({
        filename,
        teamId,
        retentionPeriod = ((_d) => (_d = config.retentionPeriod) != null ? _d : 2)()
      }) {
        const headers = {
          "retention-period": retentionPeriod.toString(),
          "Content-Type": "application/json"
        };
        if (bearerToken !== void 0) {
          headers["Authorization"] = `Bearer ${bearerToken}`;
        }
        import_api.propagation.inject(import_api.context.active(), headers);
        let response;
        try {
          response = yield fetch(
            `${baseUrl}/files/upload-url?filename=${encodeURIComponent(
              filename
            )}`,
            {
              method: "POST",
              headers,
              body: JSON.stringify({
                retentionPeriod,
                filename,
                teamId
              })
            }
          );
        } catch (error) {
          throw new Error(
            `Network error getting upload URL: ${error instanceof Error ? error.message : "Unknown error"}`
          );
        }
        if (!response.ok) {
          console.error(yield response.text());
          throw new Error(`Failed to get upload URL: ${response.status}`);
        }
        const responseJson = yield response.json();
        return {
          id: responseJson.id,
          uploadUrl: responseJson.upload_url,
          expiresAt: responseJson.expires_at
        };
      });
    },
    /**
     * Uploads a file to a pre-signed URL.
     *
     * This method uploads a file directly to cloud storage using a pre-signed URL
     * obtained from getUploadUrl(). The file is uploaded with the specified retention period.
     *
     * @param uploadUrl - The pre-signed upload URL from getUploadUrl()
     * @param file - The file to upload (File object)
     * @param retentionPeriod - Number of days to retain the file (defaults to config.retentionPeriod or 2)
     * @returns Promise that resolves when upload is complete
     * @throws Error if the upload fails (e.g., invalid URL, network error, file too large)
     */
    uploadFileToSignedURL(_0, _1) {
      return __async(this, arguments, function* (uploadUrl, file, retentionPeriod = ((_e) => (_e = config.retentionPeriod) != null ? _e : 2)()) {
        const arrayBuffer = yield file.arrayBuffer();
        let response;
        try {
          response = yield fetch(uploadUrl, {
            method: "PUT",
            headers: {
              "retention-period": retentionPeriod.toString(),
              "Content-Type": file.type || inferContentType(file.name)
            },
            body: arrayBuffer
          });
        } catch (error) {
          throw new Error(
            `Network error uploading file: ${error instanceof Error ? error.message : "Unknown error"}`
          );
        }
        if (!response.ok) {
          throw new Error(`Failed to upload file: ${response.status}`);
        }
        return response;
      });
    },
    /**
     * Gets a signed download URL for a file.
     *
     * This method requests a pre-signed URL that allows downloading a file from cloud storage
     * without exposing credentials to the client.
     *
     * @param fileId - The ID of the file to download (obtained from upload operations)
     * @returns Promise that resolves to a GetFileResponse containing the download URL and other metadata
     * @throws Error if the request fails (e.g., file not found, invalid token, network error)
     * @deprecated Use download() instead. This method will be removed in a future version.
     */
    getDownloadUrl(fileId) {
      return __async(this, null, function* () {
        const headers = {};
        if (bearerToken !== void 0) {
          headers["Authorization"] = `Bearer ${bearerToken}`;
        }
        import_api.propagation.inject(import_api.context.active(), headers);
        let response;
        try {
          response = yield fetch(`${baseUrl}/files/${fileId}/download-url`, {
            method: "GET",
            headers
          });
        } catch (error) {
          throw new Error(
            `Network error getting download URL: ${error instanceof Error ? error.message : "Unknown error"}`
          );
        }
        if (!response.ok) {
          throw new Error(`Failed to get download URL: ${response.status}`);
        }
        const responseJson = yield response.json();
        return {
          fileId: responseJson.id,
          /* @deprecated Use signedDownloadUrl instead. This property will be removed in a future version. */
          downloadUrl: responseJson.download_url,
          signedDownloadUrl: responseJson.download_url,
          expiresAt: responseJson.expires_at,
          fileSize: responseJson.file_size,
          type: responseJson.type,
          teamId: responseJson.team_id,
          filename: responseJson.filename
        };
      });
    },
    get(fileId) {
      return __async(this, null, function* () {
        return this.getDownloadUrl(fileId);
      });
    },
    download(fileId) {
      return __async(this, null, function* () {
        return this.getDownloadUrl(fileId);
      });
    },
    /**
     * Uploads a file and returns the file ID in a single operation.
     *
     * This is a convenience method that combines getUploadUrl() and uploadFileToSignedURL()
     * to simplify the upload process. It handles getting the upload URL and uploading
     * the file in sequence.
     *
     * @param file - The file to upload (File object)
     * @param uploadOptions - Options for the upload including filename, teamId, and retentionPeriod
     * @returns Promise that resolves to the file ID of the uploaded file
     * @throws Error if any step of the upload process fails
     * @deprecated Use upload() instead. This method will be removed in a future version.
     */
    uploadFileComplete(file, uploadOptions) {
      return __async(this, null, function* () {
        var _a2, _b2;
        const options = uploadOptions || { filename: file.name };
        const uploadUrlResponse = yield this.getUploadUrl(options);
        yield this.uploadFileToSignedURL(
          uploadUrlResponse.uploadUrl,
          file,
          (_b2 = (_a2 = options.retentionPeriod) != null ? _a2 : config.retentionPeriod) != null ? _b2 : 2
        );
        return uploadUrlResponse.id;
      });
    },
    /**
     * Uploads a file and returns the file ID in a single operation.
     *
     * This is a convenience method that combines getUploadUrl() and uploadFileToSignedURL()
     * to simplify the upload process. It handles getting the upload URL and uploading
     * the file in sequence.
     *
     * @param file - The file to upload (File object)
     * @param uploadOptions - Options for the upload including filename, teamId, and retentionPeriod
     * @returns Promise that resolves to the file ID of the uploaded file
     * @throws Error if any step of the upload process fails
     */
    upload(file, uploadOptions) {
      return __async(this, null, function* () {
        return this.uploadFileComplete(file, uploadOptions);
      });
    }
  };
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  STAGING_ENDPOINT,
  getFileServiceClient
});
